import reactRpc from '@square/react-rpc-client';
import { ConsoleLoggerFactory } from '@square/react-rpc-client/utils';
import { RpcError } from '../rpc/model/Error';
import { getEnvironment } from '../utilities/environment';

const loggingEnabled = getEnvironment().env !== 'production';

export default function rpc() {
  return reactRpc({
    loggerFactory: new ConsoleLoggerFactory(loggingEnabled),
    errorDeserializer: RpcError.fromResponse,
  });
}
